<template>
	<div>
        <v-flex ml-4 mt-3>
            <v-layout wrap mb-4>
                <v-flex xs12>
                     <v-layout>
                        <v-flex xs5 mr-5>
                            <v-select
                                box
                                solo
                                background-color="white"
                                class="body-1"
                                hide-details
                                label="Rol"
                                item-text="name"
                                item-value="code"
                                return-object
                                :items="roles"
                                v-model="model.role"
                            ></v-select>
                        </v-flex>   
                        <v-flex xs5>      
                            <v-text-field
                                background-color="white"
                                box
                                class="body-1"
                                hide-details
                                type="number"
                                label="Numero de Empleados"
                                v-model="model.quantity"
                                required
                            >
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout wrap mb-3>
                <v-flex xs12>
                     <v-layout>
                        <v-flex xs5 mr-5>      
                            <v-text-field
                                background-color="white"
                                box
                                class="body-1"
                                hide-details
                                label="Nombre"
                                v-model="model.name"
                                required
                            >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs5>      
                            <v-select
                                background-color="white"
                                box
                                multiple
                                clearable
                                class="body-1"
                                hide-details
                                item-text="name"
                                item-value="code"
                                label="Tipo de Documento"
                                :items="typeDocuments"
                                :return-object="false"
                                v-model="model.typeDocuments"
                            ></v-select>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
                        <v-layout wrap mb-3>
                <v-flex xs12>
                     <v-layout>
                        <v-flex xs5 mr-5>      
                            <v-text-field
                                background-color="white"
                                box
                                class="body-1"
                                hide-details
                                label="Serie"
                                type="number"
                                v-model="model.serieInit"
                                required
                            >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs5>      
                            <v-text-field
                                background-color="white"
                                box
                                class="body-1"
                                hide-details
                                type="number"
                                label="Numero inical"
                                v-model="model.employeeInit"
                                required
                            >
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-flex xs8 ml-4>
					<v-layout row wrap align-center>
						<v-flex xs5>
			    			<p class="company-text-regular ma-0">Ocultar Precio de Costo:</p>
			            </v-flex>
						<v-flex xs2 pl-2>
							<v-layout row align-center>
								<v-switch
									color="primary"
									hide-details
									v-model="model.flagNotShowCostPrice"
						    	></v-switch>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
            <v-layout wrap>
                <v-btn @click="addEmployee">
                    <v-icon small>add</v-icon>
                </v-btn>
            </v-layout>
		</v-flex>
        <v-flex ml-5 mr-4 mt-4>
            <app-table
			    :input-search="false"
				:include-filter="false"
				:columns="columns"
				:rows="users"
			>
				<template slot="rows" slot-scope="props">
					<td class="is-not-selectable" v-show="showRow(columns, 1)">
			    		{{ props.row.quantity }}
					</td>
					<td v-show="showRow(columns, 2)">
						{{ props.row.codeTypeRol }}
					</td>
					<td v-show="showRow(columns, 3)">
						{{ props.row.name }}
					</td>
                   <td v-show="showRow(columns, 4)">
						{{ props.row.password }}
					</td>
					<td v-show="showRow(columns, 5)">
						<app-tooltip-button
							color="red"
							icon="delete"
							text="Eliminar"
                            @click-icon="deleteEmployee(props.row)"
                        />
					</td>
				</template>
		    </app-table>
        </v-flex>
        <section class="modal-filter-footer">
			<modal-sidebar-button
                :is-loading="validation"
				@accept-button-clicked="saveData"
				@cancel-button-clicked="$emit('close-modal')"
			/>
		</section>
    </div>
</template>
<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function data() {
    return {
        countEmployee: 0,
        users: [],
        roles: [],
        model: {
            role: null,
            quantity: 0,
            name: '',
            typeDocuments: [],
            serieInit: 1,
            employeeInit: 1,
            flagNotShowCostPrice: false,
        },
        typeDocuments: [
            { id: 1, name: 'COTIZACION', code: 'COT' },
            { id: 2, name: 'FACTURA', code: 'FAC' },
            { id: 3, name: 'BOLETA', code: 'BOL' },
            { id: 4, name: 'NOTA DE VENTA', code: 'NTV' },
            { id: 5, name: 'PEDIDO', code: 'PED' },
        ],
        columns: [
			{ id: 1, name: 'Cantidad', checked: true, visible: true },
			{ id: 2, name: 'Rol', checked: true, visible: true },
			{ id: 3, name: 'Nombre', checked: true, visible: true },
			{ id: 4, name: 'Contraseña', checked: true, visible: true },
            { id: 5, name: 'Acción', checked: true, visible: true },
		],
    };
}

function created() {
    if (this.usersExist.length > 0) {
        this.users = this.usersExist;
    }
    this.loadRoles();
}

function validation() {
    return !this.users.length >= 1;
}

export default {
    name: 'asign-employee',
    created,
    data,
    computed: {
        validation,
    },
    components: {
        appTooltipButton,
    },
    methods: {
        addEmployee() {
            const newEmployee = {
                role: this.model.role,
                quantity: Number(this.model.quantity),
                name: this.model.name,
                typeDocuments: this.model.typeDocuments,
                serieInit: Number(this.model.serieInit),
                employeeInit: Number(this.model.employeeInit),
                flagNotShowCostPrice: this.model.flagNotShowCostPrice,
                codeTypeRol: this.model.role.code,
                uid: `EMP0${this.users.length + 1}`,
                password: 252525,
                flagAdmin: Boolean(this.model.role.isAdmin),
                flagTypePerson: 1,
                flagTerminal: false,
            };
            this.users.push(newEmployee);
            this.cleanModel();
        },
        cleanModel() {
            this.model = {
                role: null,
                quantity: 0,
                name: '',
                typeDocuments: [],
            };
        },
        async loadRoles() {
            const headers = {
                Accept: `${process.env.ACCEPT_SERVICE_V2}`,
            };
            const url = `/project/${this.codeProject}/template/${this.idTemplate}/roles`;
            const { data: response } = await this.$http.get(url, { headers, params: this.params });
            this.roles = response.data;
        },
        saveData() {
            this.users = this.users.map(user => {
                const { role, ...rest } = user;
                return rest;
            });
            this.$emit('save-data', this.users);
            // this.usersExist = [];
        },
        deleteEmployee(row) {
            this.users = this.users.filter((user) => user.id !== row.id);
        },
    },
    props: {
        idTemplate: {
            type: Number,
        },
        codeProject: {
            type: String,
        },
        usersExist: {
            type: Array,
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/configuration-general/asign-employee.vue